import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProductivityMonthly(organization_id, harvest_process_id, producer_id) {
    return RequesterV1.get(
      `organization/production/productivity_by_producer_exp/show_producer/${organization_id}/fetch_productivity_monthly/${harvest_process_id}/${producer_id}`
    );
  },

  fetchProductivityWeekly(organization_id, harvest_process_id, producer_id) {
    return RequesterV1.get(
      `organization/production/productivity_by_producer_exp/show_producer/${organization_id}/fetch_productivity_weekly/${harvest_process_id}/${producer_id}`
    );
  },

  fetchHarvestProcess(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/production/productivity_by_producer_exp/show_producer/${organization_id}/fetch_harvest_process/${harvest_process_id}`
    );
  },

  fetchProducer(organization_id, harvest_process_id, producer_id) {
    return RequesterV1.get(
      `organization/production/productivity_by_producer_exp/show_producer/${organization_id}/fetch_producer/${harvest_process_id}/${producer_id}`
    );
  }
};
